import { Component, EventEmitter, Input, Output, OnInit, HostListener, AfterViewInit, OnChanges } from '@angular/core';

@Component({
  selector: 'app-banner-category-slider',
  templateUrl: './banner-category-slider.component.html',
  styleUrls: ['./banner-category-slider.component.scss'],
})
export class BannerCategorySliderComponent implements OnInit, AfterViewInit, OnChanges {
  @Output() onCategorySelection: EventEmitter<any> = new EventEmitter();
  @Input() categoryData: any[] = [];
  @Input() currentIndex = 0;
  activeIndex = 0;
  imageItemWidth: string = '225px';
  imageContainerHeight: string = '350px';
  inactiveItemHeight: string = '77.14%';
  inactiveItemTop: string = '11.43%';

  private readonly referenceWidth = 1200;
  private readonly referenceHeight = 1080;
  private readonly referenceImageItemWidth = 225;
  private readonly referenceImageContainerHeight = 350;

  private readonly minImageItemWidth = 144;
  private readonly minImageContainerHeight = 225;

  ngOnInit(): void {
    this.activeIndex = this.currentIndex;
    this.adjustDimensions(window.innerWidth, window.innerHeight);
  }

  ngOnChanges(changes: import('@angular/core').SimpleChanges): void {
    if (changes['currentIndex'] && !changes['currentIndex'].firstChange) {
      this.activeIndex = this.currentIndex;
    }
  }

  ngAfterViewInit(): void {
    this.activeIndex = this.currentIndex;
    setTimeout(() => {
      this.adjustDimensions(window.innerWidth, window.innerHeight);
    });
  }

  trackByItems(index: number, item: any): any {
    return item.id ?? item.name;
  }

  makeActive(i: number): void {
    if (i === this.activeIndex) {
      this.onCategorySelection.emit(this.activeIndex);
    } else {
      this.activeIndex = i;
      this.onCategorySelection.emit(this.activeIndex);
    }
  }

  getPosition(index: number): number {
    const positionFromActiveIndex = index - this.activeIndex;
    return positionFromActiveIndex >= 0 ? positionFromActiveIndex : this.categoryData.length + positionFromActiveIndex;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any): void {
    this.adjustDimensions(event.target.innerWidth, event.target.innerHeight);
  }

  @HostListener('window:load', ['$event'])
  onLoad(event: Event): void {
    this.adjustDimensions(window.innerWidth, window.innerHeight);
  }

  adjustDimensions(width: number, height: number): void {
    if (width <= 768) {
      if (width > 600) {
        this.imageItemWidth = '125px';
        this.imageContainerHeight = '210px';
        this.inactiveItemHeight = '70.5%';
        this.inactiveItemTop = '14.75%';
      } else if (width > 480) {
        this.imageItemWidth = '105px';
        this.imageContainerHeight = '185px';
        this.inactiveItemHeight = '70.5%';
        this.inactiveItemTop = '14.75%';
      } else if (width > 360) {
        this.imageItemWidth = '90px';
        this.imageContainerHeight = '135px';
        this.inactiveItemHeight = '70.5%';
        this.inactiveItemTop = '14.75%';
      } else {
        this.imageItemWidth = '80px';
        this.imageContainerHeight = '145px';
        this.inactiveItemHeight = '70.5%';
        this.inactiveItemTop = '14.75%';
      }
    } else {
      const widthRatio = width / this.referenceWidth;
      const heightRatio = height / this.referenceHeight;
      const scalingFactor = Math.min(widthRatio, heightRatio);

      let newImageItemWidth = this.referenceImageItemWidth * scalingFactor;
      let newImageContainerHeight = this.referenceImageContainerHeight * scalingFactor;

      newImageItemWidth = Math.max(newImageItemWidth, this.minImageItemWidth);
      newImageContainerHeight = Math.max(newImageContainerHeight, this.minImageContainerHeight);

      this.imageItemWidth = '144px';
      this.imageContainerHeight = '225px';
      this.inactiveItemHeight = '77.14%';
      this.inactiveItemTop = '11.43%';
    }
  }
}
